export const formatBackupDate = (value?: string | null) =>
  value ? value.replace("T", " ").replace(/(\d{2}:\d{2}:\d{2})\.\d+/, "$1") : "-";
